import React from "react";
import PropTypes from "prop-types";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import MenuDrawer from "./MenuDrawer";
import MenuToolbar from "./MenuToolbar";
import { makeStyles, BottomNavigation, BottomNavigationAction } from "@material-ui/core";
import { filterArrayEqual } from "../../functions/arrays";
import { useBeforeunload } from 'react-beforeunload';
import { isMobile } from 'react-device-detect';
import { history } from '../../helpers/history';
import { useSelector } from "react-redux";
//import { useLocation } from 'react-router-dom';
/* import RestoreIcon from '@material-ui/icons/Restore';
import FavoriteIcon from '@material-ui/icons/Favorite';
import LocationOnIcon from '@material-ui/icons/LocationOn';

 */
const drawerWidth = 270;
const drawerWidthMobile = 200;
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('xs')]: {
      // width: `calc(100% - ${drawerWidthMobile}px)`,
      marginLeft: drawerWidthMobile,
    },
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidthMobile}px)`,
      marginLeft: drawerWidthMobile,
    },
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    [theme.breakpoints.up('lg')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    [theme.breakpoints.up('xl')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    backgroundColor: theme.palette.type === 'dark' ? 'inherit' : "#efefef"
    /* marginBottom: '90px' */
  },
  title: {
    flexGrow: 1,
  },
  toolbarLogo: {
    minWidth: '190px',
    [theme.breakpoints.up('xs')]: {
      width: '50%',
    },
    [theme.breakpoints.up('sm')]: {
      width: '40%',
    },
    [theme.breakpoints.up('md')]: {
      width: '20%',
    },
  },
  titleHeader: {
    color: 'rgb(0, 0, 1)',
    fontWeight: 'bold',
    fontSize: '0.875rem'
  },
  bottomNav: {
    overflow: 'hidden',
    position: 'fixed',
    bottom: '0',
    width: '100%',
    borderTop: '2px solid #a7a8a8',
    '&.MuiBottomNavigation-root': {
      height: '90px'
    }
  },
}));

const filterMenu = (menu, userPermissions) => {
  return menu
    .map(item => {
      if (item.type === "simple") {
        // Filtrar los elementos simples según el permiso
        return item.permission === undefined || userPermissions.includes(item.permission) || item.permission === 0
          ? item
          : null;
      } else if (item.type === "collapse") {
        // Filtrar subItems que cumplen con los permisos
        if (item.permission) {
          return userPermissions.includes(item.permission) || item.permission === 0
          ? item
          : null;
        }
        const filteredSubItems = (item.application_submenu || []).map(subItem => {
          return subItem.permission === undefined || userPermissions.includes(subItem.permission)
            ? subItem
            : null;
        }).filter(Boolean); // Eliminar `null`

        return filteredSubItems.length > 0 ? { ...item, application_submenu: filteredSubItems } : null;
      }
      return null;
    })
    .filter(Boolean); // Eliminar `null`
}

const ToolBar = props => {

  const { renderContainer, onNotification, onLogout, notifications, userState, timeSession, parameters, userQuestions, setOnLogoutClose, menuItems, identificationUser, devices, userDatePassword, handleOpenSnack, usernameChange } = props
  const permissions = useSelector(state => state.permissions)
  // console.log(permissions, menuItems);

  const Items = permissions.length > 0 ? filterMenu(menuItems, permissions) : []
  // console.log(Items);

  const classes = useStyles();
  const [value, setValue] = React.useState();
  /* const location = useLocation();
  console.log(location); */

  //Products()

  useBeforeunload((event) => handleClose(event));

  /* const HeaderView = () => {

    console.log(location.pathname);
  } */

  const validateLocation = () => {
    history.listen((location, action) => {
      if (location.pathname !== '/' &&
        location.pathname !== '/option-transfers' &&
        location.pathname !== '/option-payments' &&
        location.pathname !== '/credit-card-payment') {
        setValue('');
        //console.log(location.pathname)
      }
    });
  }

  /* history.listen((location, action) => {
    console.log(location.pathname)
  }); */

  const handleClose = (event) => {
    //console.log(event)
    //event.returnValue = "dfgdfgdfg"
    // setOnLogoutClose()
    //event.preventDefault()

    //
  }

  const [openSliderDrawer, setSliderDrawer] = React.useState(false);
  const handleSliderDrawerOpen = () => {
    setSliderDrawer(!openSliderDrawer);
  };

  const closeSliderDrawer = () => {
    setSliderDrawer(!openSliderDrawer)
  }

  const dateAfterLogin = (str1) => {
    return new Date(str1) <= new Date();
}

  return (
    <div className={classes.root}>
      <CssBaseline />

      <AppBar
        elevation={0}
        position="fixed"
        className={classes.appBar} >
        <MenuToolbar
          classes={classes}
          onNotification={onNotification}
          handleSliderDrawerOpen={handleSliderDrawerOpen}
          notifications={notifications}
          onLogout={onLogout}
          setOnLogoutClose={setOnLogoutClose}
          handleDarkTheme={props.handleDarkTheme}
          isDark={props.isDark}
        />
        {/*<Divider component="li" style={{ backgroundColor: '#B48518', color: 'transparent', height: '6px' }} />*/}
      </AppBar>

      <MenuDrawer
        {...props}
        primary={filterArrayEqual(parameters, 'name', 'PRIMARY_COLOR').length > 0 ? filterArrayEqual(parameters, 'name', 'PRIMARY_COLOR')[0].value : '#444242'}
        open={openSliderDrawer}
        closeDrawer={closeSliderDrawer}
        userState={userState}
        userQuestions={userQuestions}
        userDatePassword={userDatePassword}
        handleOpenSnack={handleOpenSnack}
        usernameChange={usernameChange}
        menuItems ={Items}
        identificationUser = {identificationUser}
        devices = {devices}
      />

      <main className={classes.content}>
        <div className={classes.toolbar} style={{ backgroundColor: "#FFFFFF" }} />
        {/* {renderContainer} */}<div /* style={{height:'100%'}} */>{renderContainer}</div>
        {timeSession}
        {isMobile ? <div style={{ height: '90px' }} /> : ''}

      </main>
      {isMobile ?
        <BottomNavigation
          value={value}
          onChange={(event, newValue) => {
            //console.log(value)
            //console.log(newValue)

            if(userQuestions === 1){
              history.push('/questions')
            }else{
              //(userState === 1) || (dateAfterLogin(userDatePassword))  usernameChange === 1
              if(usernameChange === 1){
                history.push('/username-change')
              }else{
                if((userState === 1) || (dateAfterLogin(userDatePassword))){
                  handleOpenSnack('COOP GAÑANSOL le recomienda cambiar su contraseña cada cierto tiempo por cuestiones de seguridad de su información.', 'info')
                  history.push('/password-change')
                }else{
                  if (newValue === 0) {
                    history.push('/')
                  } else if (newValue === 1) {
                    history.push('/option-transfers')
                  } else if (newValue === 2) {
                    history.push('/option-payments')
                  } else if (newValue === 3) {
                    history.push('/transfers-qr')
                  } else {
                    history.push('/credit-card-payment')
                  }
                  setValue(newValue);
                  validateLocation()
                }
              }
            }
          }}
          showLabels
          className={classes.bottomNav}
        >
          <BottomNavigationAction label="Mis Productos"
            icon={value === 0 ? <img src={process.env.PUBLIC_URL + '/buttons/mis_productos_active.png'} alt="Logo" style={{ width: '40%'}} /> :
              <img src={process.env.PUBLIC_URL + '/buttons/mis_productos.png'} alt="Logo" style={{ width: '40%' }} />} style={{ fontSize: '1px' }}  />
          <BottomNavigationAction label="Transferencias"
            icon={value === 1 ? <img src={process.env.PUBLIC_URL + '/buttons/transferencias_active.png'} alt="Logo" style={{ width: '40%'}} /> :
              <img src={process.env.PUBLIC_URL + '/buttons/transferencias.png'} alt="Logo" style={{ width: '40%' }} />} style={{ fontSize: '1px' }} />
          <BottomNavigationAction label="Pago de Servicios"
            icon={value === 2 ? <img src={process.env.PUBLIC_URL + '/buttons/pago_servicios_active.png'} alt="Logo" style={{ width: '40%'}} /> :
              <img src={process.env.PUBLIC_URL + '/buttons/pago_servicios.png'} alt="Logo" style={{ width: '40%' }} />} style={{ fontSize: '1px' }} />
          <BottomNavigationAction label="SOLPay"
            icon={value === 3 ? <img src={process.env.PUBLIC_URL + '/buttons/sol_pay_logo.png'} alt="Logo" style={{ width: '40%', textAlign: 'center'}} /> :
              <img src={process.env.PUBLIC_URL + '/buttons/sol_pay_logo.png'} alt="Logo" style={{ width: '40%' }} />} style={{ fontSize: '1px' }} />
        </BottomNavigation> : ''}
    </div>
  );
};

ToolBar.propTypes = {
  onLogout: PropTypes.func.isRequired,
};

export default ToolBar;
